import Chart from 'chart.js/auto'
import { colors, doughnutChartOptions } from './chart_config'

export function buildEngagementChart(canvas, data) {
  return new Chart(canvas, {
    type: 'doughnut',
    data: {
      labels: data.labels,
      datasets: [{
        data: data.data,
        backgroundColor: [
          colors.purple[300],
          colors.purple[500],
          colors.purple[600],
          colors.purple[800]
        ],
        borderWidth: 0,
        hoverOffset: 4
      }]
    },
    options: {
      ...doughnutChartOptions,
      plugins: {
        ...doughnutChartOptions.plugins,
        tooltip: {
          ...doughnutChartOptions.plugins.tooltip,
          callbacks: {
            label: (item) => {
              const total = item.dataset.data.reduce((a, b) => a + b, 0)
              const percentage = ((item.raw / total) * 100).toFixed(1)
              return `${item.raw.toLocaleString()} users (${percentage}%)`
            }
          }
        }
      }
    }
  })
}
